import './Home.scss'
import { useContext, useEffect, useRef, useState } from 'react';
import Category from '../../Components/Category/Category';
import {TemplateContext} from "../../Contexts/TemplateProvider"
import { Responsive, WidthProvider } from "react-grid-layout";
import DashboardItem from '../../Components/DashboardItem/DashboardItem';
import Loading from '../../Components/Loading';
export default function Home(){
  const { templateCategories,refreshTemplate,currentCategory,updateCurrentCategory } = useContext(TemplateContext);
  const [loading, setLoading] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0);
  const [lay, setLay] = useState();
  const [children, setChildren] = useState([]);
  const sidebarRef = useRef();
  const indicatorRef = useRef();
  useEffect(()=>{
    document.title = "Dashboard"
  },[])
  function updateLayout(key){
    const currentLayout = localStorage.getItem(key)
    setLay(JSON.parse(currentLayout))
  }
  const ResponsiveGridLayout = WidthProvider(Responsive);
  useEffect(() => {
    refreshTemplate()
      setTimeout(() => {
        const sidebarItem = sidebarRef.current.querySelector('.categoriesContainer');
        indicatorRef.current.style.width = `${Math.min(sidebarItem.clientWidth/3)}px`;
      }, 50);
}, [refreshTemplate]);

    // change active index
    useEffect(() => {
      setActiveIndex(null)
      setLoading(true)
      if(currentCategory){
        const activeItem = templateCategories.findIndex(item => item.categoryName === currentCategory.categoryName);
        setActiveIndex(currentCategory.categoryName.length === 0 ? 0 : activeItem);
        const a = []
        async function changeLayout(){
          await updateLayout(currentCategory.categoryName)
          await currentCategory.sdg.forEach((SDG) =>{
            if(SDG.mvogoal.length > 0){
              SDG.mvogoal.forEach((mvo) => {
                a.push(mvo)
              })
            }
          })
        setChildren(a.map((mvo) => <div key={mvo.MVOgoalId}><DashboardItem data={mvo}/></div>))
        setTimeout(() => {
          setLoading(false) 
        }, 750); 
        }
        changeLayout()
        }
  }, [currentCategory,templateCategories]);

  const [layouts, setLayouts] = useState()
  useEffect(() => {
    if (lay){
      setLayouts({"lg": lay,"md":lay, "sm": lay, "xs": lay, "xxs": lay})
    }
  },[lay])
  return (
          <div ref={sidebarRef} className='HomeContainer'>
            {templateCategories.length >0 && 
        <div className='categoriesContainer' required data-cy='categorieContainer'>
        <div
        ref={indicatorRef}
        className="highlightCategory"
        style={{
            transform: `translateX(${(activeIndex * (112))}px)`,
            }}></div>
          {templateCategories.map((category,index) => {        
             return (<div key={category.categoryName} className={`CategoryItem ${activeIndex === index ? 'active' : ''}`} style={{"zIndex":"2"}} onClick={() => updateCurrentCategory(category)}><Category CategoryName={category.categoryName}/></div>) 
          })}
        </div>}
        <div className='main' required data-cy='Dashboard_items'>
          {loading === true && <Loading type="spin" color="#004C69"/>}
          {activeIndex != null && layouts && loading !== true &&
    <ResponsiveGridLayout
    isDraggable={false}
    isResizable={false}
    className="layout"
    measureBeforeMount={true}
    useCSSTransforms={false}
    layouts={layouts}
    breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
    cols={{ lg: 20, md: 10, sm: 6, xs: 4, xxs: 2 }}
    rowHeight={33}
  >
    {children}
  </ResponsiveGridLayout>}
        </div>
      </div>
      

      
  );
}